import React from 'react';

import { Props } from './content-item';
import ContentItemStandardContent from './content-item-default-content';
import ContentItemLiveTVContent from './content-item-live-tv-content';

export const ContentItemContentSelector: React.FC<Props> = (props: Props) => {
  const { children, liveTV } = props;

  return liveTV ? (
    <ContentItemLiveTVContent {...props}>{children}</ContentItemLiveTVContent>
  ) : (
    <ContentItemStandardContent {...props}>{children}</ContentItemStandardContent>
  );
};

export default ContentItemContentSelector;
